<template>
  <a-layout>
    <br/>
    <a-space>
      <a-input-search v-model="query['item.no']" :placeholder="$t('business.label.itemNo')" @pressEnter="search()" @search="search()"/>
      <a-input-search v-model="query['item.name']" :placeholder="$t('business.label.itemName')" @pressEnter="search()" @search="search()"/>
      <a-input-search v-model="query['lot.no']" :placeholder="$t('business.label.lot')" @pressEnter="search()" @search="search()"/>
    </a-space>
    <br/>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
      <vxe-column field="lot.no" title="business.label.lot"/>
      <vxe-column field="location.no" title="business.label.location"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoom"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="command.actualQuantity" title="business.label.quantity"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'DeliverPrintDetail',
  data() {
    return {
      data: [],
      contentSize: 0,
      page: 1,
      size: 5,
      loading: false,
      query: {
        'order.id': null,
        original: true,
        'item.no': '',
        'item.name': '',
        'lot.no': ''
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.3)
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    getData(orderId) {
      if (orderId) {
        this.query['order.id'] = orderId
      }
      if (this.query['order.id'] === null || this.query['order.id'] === undefined) {
        return
      }
      this.loading = true
      findAll('shipmentCommandFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
        this.loading = false
      })
    },
    search() {
      this.page = 1
      this.getData()
    },
    reset() {
      this.query['item.no'] = ''
      this.query['item.name'] = ''
      this.query['lot.no'] = ''
      this.page = 1
      this.data = []
    }
  }
}
</script>
